import { Typography } from 'antd'
import PropTypes from 'prop-types'
import { useCallback } from 'react'
import { useNavigate, Navigate } from 'react-router-dom'
import { useTheme } from 'react-jss'
import Filters from '../Forms/Filters'
import {
  useCurrentUserPracticeId,
  useIsAdmin,
} from '../../redux/slices/session'

const { Title } = Typography

export default function PracticeSelectView({ routeMethod }) {
  const { brandPrimary } = useTheme()
  const navigate = useNavigate()
  const nav = useCallback(
    ({ practiceId }) => {
      if (practiceId) {
        navigate(routeMethod({ practiceId }))
      }
    },
    [navigate, routeMethod],
  )
  const isAdmin = useIsAdmin()
  const currentPracticeId = useCurrentUserPracticeId()

  if (isAdmin) {
    return (
      <div>
        <Title level={4} style={{ color: brandPrimary }}>
          Please select a practice:
        </Title>
        <Filters showInactiveCheck showPractice bigPractice onSubmit={nav} />
      </div>
    )
  }

  return <Navigate to={routeMethod({ practiceId: currentPracticeId })} />
}

PracticeSelectView.propTypes = {
  routeMethod: PropTypes.func.isRequired,
}
